import { z } from 'zod';

export const equipmentAttachmentSchema = z.object({
  type: z.string(),
  source: z.string(),
  id: z.string().uuid(),
  createdDateTime: z.string(),
});

export const uploadEquipmentAssetsResponse = z.object({
  equipment: z.object({
    result: z.object({
      success: z.boolean(),
      error: z.string().nullable(),
      entities: z.array(equipmentAttachmentSchema),
    }),
  }),
});

export const uploadEquipmentAssetsVariables = z.object({
  input: z.object({
    type: z.string(),
    entityId: z.string().uuid(),
    assets: z.array(z.any()),
  }),
});

export const deleteEquipmentAssetResponse = z.object({
  equipment: z.object({
    result: z.object({
      success: z.boolean(),
      error: z.string().nullable(),
      entity: equipmentAttachmentSchema,
    }),
  }),
});

export const deleteEquipmentAssetVariables = z.object({
  input: z.object({
    id: z.string().uuid(),
  }),
});

export const getEquipmentAssetsResponse = z.object({
  equipment: z.object({
    result: z.object({
      assets: z.array(equipmentAttachmentSchema),
    }),
  }),
});

export const getEquipmentAssetsVariables = z.object({
  input: z.object({
    entityId: z.string().uuid(),
  }),
});
